var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.footer.tipo == 1)?[_c('LayoutSports')]:_vm._e(),(_vm.footer.tipo == 2)?[_c('LayoutTeatros')]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }